import { schema } from 'normalizr'
import {
  createEntitiesSelector,
  createSelectorForEntityKey,
  actionCrudCreatorsFor,
} from '@infotech/lib-api-middleware'
import { TOIR_CORE_URL } from './constants'

export const TOIR_ISSUE_TYPES_SCHEMA_NAME = `toirIssueTypes`
export const URL = `${TOIR_CORE_URL}/core/issues/types`

const toirIssueTypesSchema = new schema.Entity(TOIR_ISSUE_TYPES_SCHEMA_NAME)
export const toirIssueTypesSelector = createSelectorForEntityKey(TOIR_ISSUE_TYPES_SCHEMA_NAME)
export const toirIssueTypesEntitiesSelector = createEntitiesSelector(TOIR_ISSUE_TYPES_SCHEMA_NAME)
export const toirIssueTypesApiActions = actionCrudCreatorsFor(TOIR_ISSUE_TYPES_SCHEMA_NAME, URL, toirIssueTypesSchema)
